/**
 * Обмен страницы с service worker при записи файла потоком (адрес /__download/<id>).
 * Страница открывает MessageChannel: DOWNLOAD_START уходит воркеру с портом, дальше по порту
 * идут куски по порядку, конец и отмена; воркер по порту выдаёт кредит — сколько кусков он
 * готов принять, чтобы страница не копила их в памяти быстрее, чем браузер пишет на диск.
 */
export enum EnumDownloadMessage {
  START = 'DOWNLOAD_START',
  CHUNK = 'DOWNLOAD_CHUNK',
  END = 'DOWNLOAD_END',
  ABORT = 'DOWNLOAD_ABORT',
  /** Воркер -> страница: можно отправить ещё credit кусков */
  CREDIT = 'DOWNLOAD_CREDIT',
}

export interface IDownloadStart {
  type: EnumDownloadMessage.START
  id: string
  name: string
  size: number
}

export interface IDownloadChunk {
  type: EnumDownloadMessage.CHUNK
  bytes: Uint8Array
}

export interface IDownloadEnd {
  type: EnumDownloadMessage.END
}

export interface IDownloadAbort {
  type: EnumDownloadMessage.ABORT
}

export interface IDownloadCredit {
  type: EnumDownloadMessage.CREDIT
  credit: number
}

export type DownloadPortMessage = IDownloadChunk | IDownloadEnd | IDownloadAbort

/** Порт обмена: обе стороны пользуются только этим подмножеством MessagePort */
export interface IDownloadPort {
  postMessage(message: unknown, transfer?: Transferable[]): void
  onmessage: ((event: { data: unknown }) => void) | null
  close(): void
}

export const DOWNLOAD_PATH = '/__download/'
